<div class="data-source">
    <div class="row error-message-validations">
        <wms-message type="alertMessages.type" [scopeDataset]="alertMessages" hideClose="false"></wms-message>
    </div>
    <div class="row select-data-source">
        <wms-spinner *ngIf="showSpinner"></wms-spinner>
        <form class="wm-form full-height">
            <div class="col-xs-6 select-var-creation">
                <div class="wm-form-row clearfix">
                    <label class="form-label col-xs-4">{{locale.LABEL_RETRIEVE_DATA}}</label>

                    <div class="col-xs-8 retrive-data-options">
<!--                      // TODO:name is changed from datasource to datasource1 to  different radioset-->

                        <label class="radio-inline">
                            <input type="radio" name="datasource1" [ngModel]="widgetConfig.bindMode" value="variable" (ngModelChange)="setActiveTab('variable')" /> {{locale.LABEL_SERVICES}}
                        </label>
                        <label class="radio-inline" *ngIf="!(widgetDetails.widgetType === 'wm-form')">
                            <input type="radio" name="datasource2" [disabled]="!widgetsAvailable" [ngModel]="widgetConfig.bindMode" value="widget" (ngModelChange)="setActiveTab('widget')" /> {{locale.LABEL_WIDGETS}}
                        </label>
                        <label class="radio-inline" >
                            <input type="radio" name="datasource3" [ngModel]="widgetConfig.bindMode" value="existing" (ngModelChange)="setActiveTab('existing')" /> {{locale.LABEL_EXISTING_VARIABLE}}
                        </label>
                    </div>
                </div>
                <div class="data-source-variable col-xs-12" *ngIf="widgetConfig.bindMode === 'variable' || widgetConfig.bindMode === 'existing'">
                    <div class="wm-form-row col-xs-12 clearfix" *ngIf="!isSourceMode">
                        <label class="form-label col-xs-4">{{widgetType === 'wm-form' ? locale.LABEL_SUBMIT_API_VARIABLE : locale.LABEL_SELECT_VARIABLE}}</label>

                        <div class="col-xs-8">
                            <wms-typeahead name="wms-variables-data-source" placeholder="{{locale.LABEL_SEARCH_EXISTING_VARIABLE}}" [model]="variableFilter" [options]="dataSourceOptions" (onClear)="setActiveTab()"
                                           (onSelect)="getTypesByService($event)" propertyName="name" groupBy="category" customDropdownClass="properties-typeahead-dropdown"></wms-typeahead>
                        </div>
                    </div>
                    <div class="col-xs-12" *ngIf="isSourceMode && dataSource.length">

                        <div class="wm-form-row clearfix">
                            <label class="form-label col-xs-4">{{locale.LABEL_SELECT_SERVICE_TYPE}}</label>

                            <div class="col-xs-8">
                                <select [ngModel]="variableCategoryFilter" (ngModelChange)="setVariableCategoryFilter.emit($event)" name="wm-addvariable-category-filter" title="{{locale['MESSAGE_HELP_VARIABLE_FILTER_TYPE']}}" class="app-select form-control">
                                    <option *ngFor="let type of categoryFilterList | keyvalue" [value]="type.key">{{type.value}}</option>
                                </select>
                                <!-- <wm-select name="wm-addvariable-category-filter" scopedatavalue="variableCategoryFilter" scopedataset="categoryFilterList"
                                           title="{{locale['MESSAGE_HELP_VARIABLE_FILTER_TYPE']}}" on-change="filterDataSource(variableCategoryFilter)"></wm-select> -->
                            </div>
                        </div>

                        <div class="wm-form-row clearfix" *ngIf="filteredDataSources.length">
                            <label class="form-label col-xs-4">{{locale.LABEL_SELECT_SERVICE}}</label>

                            <div class="col-xs-8">
                                <wms-typeahead name="wms-source-data-source" placeholder="{{locale.MESSAGE_PLACEHOLDER_SELECT_DATA_SOURCE}}" [model]="selectedDataSource.source" [options]="filteredDataSources" (onSelect)="onServiceSelect($event)"
                                               (onClear)="setActiveTab()" propertyName="name" groupBy="displayType"></wms-typeahead>
                            </div>
                        </div>

                        <div class="wm-form-row clearfix" *ngIf="selectedDataSource.source && (selectedDataSource.source.type !== variableConstants.SERVICE_TYPE_WEBSOCKET) && (selectedDataSource.source.type !== variableConstants.SERVICE_TYPE_REST) && selectedDataSource.operations.length">
                            <label class="form-label col-xs-4">{{locale[operationText]}}:</label>

                            <div class="col-xs-8">
                                <wms-typeahead name="wms-source-data-operation" placeholder="{{locale.MESSAGE_PLACEHOLDER_SELECT}} {{locale[operationText]}}" [model]="selectedDataSource?.operation" [options]="selectedDataSource?.operations"
                                               (onClear)="treeData = false; onOperationClear.emit()" (onSelect)="onOperationSelect($event)" propertyName="name" groupBy="displayType"></wms-typeahead>
                            </div>
                        </div>
                        <div class="wm-form-row clearfix" *ngIf="selectedDataSource?.operation">
                            <label class="form-label col-xs-4">{{locale.LABEL_VARIABLE_NAME}}:</label>

                            <div class="col-xs-8">
                                <input name="variable-name-input" class="app-text form-control" type="text" [(ngModel)]="selectedDataSource.variableNameCreate"
                                       [ngModelOptions]="{updateOn: 'blur'}" placeholder="{{locale.LABEL_INSERT_VARIABLE_PLACEHOLDER}}" [maxlength]="variableNameLimit"
                                       (ngModelChange)="updateGeneratedVariableName.emit(selectedDataSource.variableNameCreate)">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Widget selection start -->
                 <div class="data-source-widget col-xs-12" *ngIf="widgetConfig.bindMode === 'widget'">
                    <div class="wm-form-row clearfix">
                        <label class="form-label col-xs-4">{{locale.LABEL_SELECT_A_WIDGET}}</label>

                        <div class="col-xs-8">
                            <select name="wm-select-widget" class="app-select form-control" [(ngModel)]="widgetFilter" (change)="updateBindMapTreeSelect(widgetFilter)">
                                <option [value]=""  >{{locale.LABEL_WIDGET_DESIGNER_SELECT_A_WIDGET}}</option>
                              <option *ngFor="let widgets of widgetList |keyvalue  " [ngValue]="widgets.value" >{{widgets.key}}</option>

                            </select>
                        </div>

                    </div>
                </div>
                <!-- Widget selection end -->

                <!-- New service config start -->
                <div class="col-xs-12 clearfix data-configure" *ngIf="selectedDataSource.operation || (widgetType === 'wm-table' && variableFilter?.category === 'wm.ServiceVariable')">
                    <h4>{{locale.LABEL_DATA_CONFIGURATION}}</h4>
                </div>
                <div class="data-source-variable col-xs-12" *ngIf="selectedDataSource.operation">
                    <div class="wm-form-row clearfix"
                         *ngIf="selectedDataSource.operation && (selectedDataSource.operation.type === 'QueryExecution' || selectedDataSource.operation.type === 'Entities')">
                        <label class="form-label col-xs-4">{{locale.LABEL_VARIABLE_PROPERTIES_MAXRESULTS}}</label>
                        <div class="col-xs-8">
                            <input name="maxresults-input" class="app-text form-control max-results" type="number" min="1" [(ngModel)]="selectedDataSource.maxResults" (blur)="checkSelectedDataSourceMaxResult()">
                            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_VARIABLE['wm.LiveVariable'].MAXRESULTS}}" class="wm-icon wms wms-help"></i>
                        </div>
                    </div>
                    <div *ngIf="selectedDataSource.operation.serviceType !== 'wm.WebSocketVariable'">
                        <div class="wm-form-row clearfix">
                            <div class="col-xs-4"></div>
                            <div class="col-xs-8">
                                <input name="autoupdate-input" class="app-checkbox" type="checkbox" [(ngModel)]="selectedDataSource.autoUpdate">
                                <label class="form-label trigger-service" *ngIf="selectedDataSource.operation.serviceType !== 'wm.CrudVariable'">{{locale.LABEL_VARIABLE_PROPERTIES_AUTOUPDATE}}</label>
                                <label class="form-label trigger-service" *ngIf="selectedDataSource.operation.serviceType === 'wm.CrudVariable'">{{locale.LABEL_CRUD_VARIABLE_PROPERTIES_AUTOUPDATE}}</label>
                                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_VARIABLE['wm.LiveVariable'].AUTOUPDATE}}" class="wm-icon wms wms-help"></i>
                            </div>
                        </div>
                        <div class="wm-form-row clearfix">
                            <div class="col-xs-4"></div>
                            <div class="col-xs-8">
                                <input name="startupdate-input" class="app-checkbox" type="checkbox" [(ngModel)]="selectedDataSource.startUpdate">
                                <label class="form-label trigger-service" *ngIf="selectedDataSource.operation.serviceType !== 'wm.CrudVariable'">{{locale.LABEL_VARIABLE_PROPERTIES_STARTUPDATE}}</label>
                                <label class="form-label trigger-service" *ngIf="selectedDataSource.operation.serviceType === 'wm.CrudVariable'">{{locale.LABEL_CRUD_VARIABLE_PROPERTIES_STARTUPDATE}}</label>
                                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_VARIABLE['wm.LiveVariable'].STARTUPDATE}}" class="wm-icon wms wms-help"></i>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedDataSource.operation.serviceType === 'wm.WebSocketVariable'">
                        <div class="wm-form-row clearfix">
                            <div class="col-xs-4">
                                <label class="form-label trigger-service">{{locale.LABEL_VARIABLE_PROPERTIES_CONNECTONPAGELOAD}}</label>
                            </div>
                            <div class="col-xs-8">
                                <input name="connect-on-page-load" class="app-checkbox" type="checkbox" [(ngModel)]="selectedDataSource.startUpdate">
                                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_VARIABLE['wm.WebSocketVariable'].STARTUPDATE}}" class="wm-icon wms wms-help"></i>
                            </div>
                        </div>
                        <div class="wm-form-row clearfix">
                            <label class="form-label col-xs-4">{{locale.LABEL_VARIABLE_PROPERTIES_DATAUPDATESTRATEGY}}</label>
                            <div class="col-xs-8">
                                <select name="wm-select-widget" class="app-select form-control"
                                        [(ngModel)]="selectedDataSource.dataUpdateStrategy">
                                        <option *ngFor="let item of selectedDataSource?.dataUpdateStrategyOptions | keyvalue" [value]="item.key">{{item.value}}</option>
                                </select>
                                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_VARIABLE['wm.WebSocketVariable'].DATAUPDATESTRATEGY}}" class="wm-icon wms wms-help"></i>
                            </div>
                        </div>
                        <div class="wm-form-row clearfix"
                             *ngIf="selectedDataSource.dataUpdateStrategy !== 'refresh'">
                            <label class="form-label col-xs-4">{{locale.LABEL_VARIABLE_PROPERTIES_DATALIMIT}}:</label>
                            <div class="col-xs-8">
                                <input name="data-limit" class="app-text form-control max-results" type="number" min="1" [(ngModel)]="selectedDataSource.dataLimit">
                                <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_VARIABLE['wm.WebSocketVariable'].DATALIMIT}}" class="wm-icon wms help"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div  class="col-xs-12" *ngIf="widgetType === 'wm-table' && variableFilter?.category === 'wm.ServiceVariable' && (!isSourceMode || selectedDataSource.operation)">
                    <div class="wm-form-row clearfix">
                        <div class="col-xs-4"></div>
                        <div class="col-xs-8">
                            <input class="app-checkbox" name="dynamic-metadata-checkbox" type="checkbox" [ngModel]="currentStep.dynamicWidget" (ngModelChange)="onDynamicWidgetChange.emit($event)">
                            <label class="form-label trigger-service">{{widgetType === 'wm-table' ? locale.LABEL_DYNAMIC_GRID_METADATA : locale.LABEL_DYNAMIC_FORM_METADATA}}</label>
                            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{widgetType === 'wm-table' ? locale.MESSAGE_DYNAMIC_GRID_METADATA : locale.MESSAGE_DYNAMIC_FORM_METADATA}}" class="wm-icon wms wms-help"></i>
                        </div>
                    </div>
                    <div class="wm-form-row clearfix" *ngIf="currentStep.dynamicWidget && widgetType === 'wm-form'">
                        <label class="form-label col-xs-4">{{locale.LABEL_PROPERTY_METADATA}} :</label>
                        <div class="col-xs-8">
                            <wms-typeahead name="wms-variables-metadata-source" placeholder="{{locale.LABEL_SEARCH_EXISTING_VARIABLE}}" [model]="metadataFilter" [options]="metadataVariableList"
                                           (onSelect)="updateBindMapTree.emit(model)" propertyName="name" groupBy="category"></wms-typeahead>
                        </div>
                    </div>
                </div>
                <!-- New serivce config end -->
            </div>
            <!-- Binding tree start -->
            <div class="col-xs-6" *ngIf="variableFilter || widgetFilter">
                <div class="data-source-service col-xs-12" *ngIf="treeData?.length > 0">
                    <div class="wm-form-row clearfix">
                        <label class="form-label">{{locale.LABEL_SELECT_DATANODE}}</label>

                        <div class="col-xs-12 select-data-node">
                            <wms-tree [data]="treeData" (nodeClick)="handleNodeClick($event)" sortBy="id" [getChildren]="bindVariableService.getChildren" icontype="plus" [selectedNode]="selectedNode"></wms-tree>
                            <div class="wm-message clearfix" *ngIf="validation.message">
                                <i class="validation-icon pull-left {{validation.icon}}"></i>

                                <p class="message-container pull-left">
                                    {{locale[validation.message]}}<br/>{{locale.LABEL_TYPE}}: {{validation.selectedDataSourceType}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Binding tree end -->
        </form>
    </div>
    <!-- Empty services config start -->
    <div *ngIf="widgetConfig.bindMode === 'variable' && ((isSourceMode && !dataSource.length) || (!filteredDataSources.length && dataSource.length))">
        <wms-spinner *ngIf="showServiceSpinner" [caption]="locale.MESSAGE_LOADING_SERVICES"></wms-spinner>
        <p *ngIf="!showServiceSpinner" class="ci-datasource-header">{{dataSource.length && !filteredDataSources.length ? locale.MESSAGE_NO_SOURCE_FOR_SELECTED_SERVICE : locale.MESSAGE_NO_SOURCE}}</p>
      <div class="row ci-datasource">
            <div class="ci-datasource-header-tile">
              <span *ngIf="(showDesignButton?.all || showDesignButton?.database) && (widgetType==='wm-liveform' ||  widgetType==='wm-livefilter')">
                <button *wmsFeature="preferences.project.database.create" name="ci-datasource-data-model" class="btn button-primary" (click)="newService('DATABASE_CREATE')">
                    {{locale.LABEL_SERVICES_DESIGN_DATAMODEL}}
                </button>
              </span>
              <span *ngIf="(showDesignButton?.all || showDesignButton?.database)">
                <button *wmsFeature="preferences.project.database.create" name="ci-datasource-data-import" class="btn button-primary" (click)="newService('DATABASE_IMPORT')">
                    {{locale.LABEL_IMPORT}} {{locale.LABEL_DATABASE}}
                </button>
              </span>
              <span *ngIf="(showDesignButton?.all || showDesignButton?.web) && widgetType !=='wm-liveform' &&  widgetType !=='wm-livefilter'">
                <button *wmsFeature="preferences.project.rest.create || preferences.project.soap.create || preferences.project.websocket.create || preferences.project.openapi.create"
                        name="ci-datasource-web-service"
                        class="btn button-primary" (click)="newService('WEB_SERVICE', $event)">
                    {{locale.LABEL_IMPORT}} {{locale.LABEL_WEB_SERVICE}}
                </button>
              </span>
              <span *ngIf="(showDesignButton?.all || showDesignButton?.java) && widgetType !=='wm-liveform' &&  widgetType !=='wm-livefilter'">
                <button *wmsFeature="preferences.project.javaservice.create" name="ci-datasource-java-service" class="btn button-primary" (click)="newService('JAVA_SERVICE')">
                    {{locale.LABEL_CREATE}} {{locale.LABEL_JAVA_SERVICE}}
                </button>
              </span>
            </div>
        </div>
    </div>
    <!-- Empty services config end -->
</div>
